module.exports = __webpack_public_path__ + "img/collection-diamondJewelryPlatinum@2x.ffe75c5.jpg";